// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://jcdkjsslrdyvemoyocxc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpjZGtqc3NscmR5dmVtb3lvY3hjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQ4OTM5NTksImV4cCI6MjA1MDQ2OTk1OX0._LjPwLqCafZk5LNABh1QuLXfzepfNgqH-Dy8wVr9bTs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);